const Lang = require('lang');
const moment = require('moment');
const GlobalAlerts = require('global_alerts');
const ga4 = require('../ga4/ga4');

/**
 * Adiciona uma notificação a lista, recebida via websocket
 *
 * `icon`: icone referente ao svg incluso no projeto
 * `shouldDownloadOnClick`: determina se o recurso deve ser baixado ao clique
 */
const notificationProps = {
  pdf_ready: {
    icon: 'sheet',
    shouldDownloadOnClick: true
  },
  default: {
    icon: 'sheet',
    shouldDownloadOnClick: false
  },
};

$('#notifications-dropdown').on('click', 'img.dots-svg, .dropdown-menu-left', function (e) {
  e.preventDefault();
  e.stopPropagation();
});

$('#notifications-dropdown').on('show.bs.dropdown', 'img.dots-svg ', function (e) {
  $('.dropdown-menu-left.show').removeClass('show');
});

$('#notifications-dropdown').on('click', '.notifications-read-all', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $('#read-all-loader').addClass('loader');
  $('.notifications-read-all').addClass('disabled');

  markAllRead();
});

$('#notifications-dropdown').on('click', '.mark-read-unread', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const parent = $(e.target).parent();
  $(e.target).closest('.dropdown-menu-left').removeClass('show');
  $(e.target).closest('li .notification-card').addClass('disable-click');
  parent.siblings('#read-notification-loader').addClass('loader');
  parent.siblings('img.dots-svg').addClass('hidden');

  toggleNotificationRead($(e.target).data(), $(e.target));
});

$('#notifications-dropdown').on('click', 'li .notification-card', function (e) {
  e.preventDefault();
  e.stopPropagation();

  ga4.event('vex_home_notif_item')();

  const element = $(e.target).closest('li .notification-card');
  const dataset = element.data();
  element.addClass('disable-click');

  if (!dataset.isRead) {
    toggleNotificationRead(dataset, element, true);
  }

  if (dataset.notificationType === 'pdf_ready') {
    element.removeClass('disable-click');
    window.open(element.attr('href'), '_blank');
  } else if (dataset.notificationType === 'invoice_tax_receipt_added') {
    openTaxReceipt(element);
  } else {
    window.location.href = element.attr('href');
  }
});

$('#notifications-dropdown').on('click', '.notifications-load-more', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $('#load-more-loader').addClass('loader');
  $('.notifications-load-more').addClass('hidden');

  const nextPage = $(e.target).data('nextPage');

  loadMore(nextPage);
});

$(function () {
  const loginSnackbar = $('.login-snackbar')
  const showSnackbar = loginSnackbar.data('showSnackbar');

  if (showSnackbar) {
    loginSnackbar.addClass('show-snackbar');

    setTimeout(() => {
      loginSnackbar.remove();
    }, 7500);
  }
});

$('#navigation-container').on('click', '.login-snackbar-container', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $('.login-snackbar').removeClass('show-snackbar');
  $('#notifications-dropdown').addClass('show');
});

$('#navigation-container').on('click', '.notification-snackbar-container', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const element = $(e.target).closest('.notification-snackbar-container');
  const dataset = element.data();
  const notificationElement = $(`li .notification-card[data-notification-id=\"${dataset.notificationId}\"]`);

  element.closest('#snackbar').removeClass('show-snackbar');
  toggleNotificationRead(dataset, notificationElement, true);

  if (dataset.notificationType === 'pdf_ready') {
    element.removeClass('disable-click');
    window.open(element.attr('href'), '_blank');
  } else {
    window.location.href = element.attr('href');
  }
});

$('#navigation-container').on('click', '.snackbar-close', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $(e.target).closest('#snackbar').removeClass('show-snackbar');
});

$('#navigation-container').on('click', '.tabs-item-container', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const isActive = $(this).hasClass('active');

  if (isActive) { return };

  $('.tabs-container .tabs-item-container').removeClass('active');

  $(this).addClass('active');

  filterActiveNotifications();
});

/**
 * Envia a request de marcar uma notificação como lida ou não lida
 *
 * @param {Object} data
 * @param {element} element
 * @param {bool} redirect
 *
 */
function toggleNotificationRead(data, element, redirect = false) {
  const isRead = data.isRead;
  const type = data.notificationType;
  const notificationId = data.notificationId;
  const urlName = isRead ?
    'app.notificacoes.marcar-nao-lido' :
    'app.notificacoes.marcar-lido';

  sendRequest('POST', route(urlName, notificationId))
    .done(() => {
      if (
        !redirect ||
        type === 'pdf_ready' ||
        type === 'invoice_tax_receipt_added'
      ) {
        updateBadges(isRead, element, type);
      }

      removeClasses(element);
    })
    .fail(() => {
      removeClasses(element);

      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    });
};

/**
 * Envia a request de marcar todas notificações como lidas
 *
 */
function markAllRead() {
  const urlName = 'app.notificacoes.marcar-todas-lido';
  const activeTab = $('[data-notification-tab].active').data('notification-tab');

  if (activeTab !== 'all') {
    // Usa a mesma sintaxe dos dados ao clicar em 1 por 1 no botão de read-unread
    const notifications = $('.notifications section').find('li:visible .mark-read-unread.read-control');

    notifications.each(function () {
      const dataset = $(this).data();

      if (dataset.isRead) { return; }

      toggleNotificationRead($(this).data(), $(this));
    });

    $('#read-all-loader').removeClass('loader');
    return;
  }

  sendRequest('POST', route(urlName))
    .done(() => {
      $('li .unread').each((index, element) => {
        $(element).find('.mark-read-unread').data('isRead', 1);
        $(element).find('.mark-read-unread')
          .text(Lang.get('js/src/notificacoes/notificacoes.mark_unread'));
        $(element).removeClass('unread').addClass('read');
      })

      resetReadAllClasses()
    })
    .fail(() => {
      $('#read-all-loader').removeClass('loader');
      $('.notifications-read-all').removeClass('disabled');
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    });
};

/**
 * Diz qual a sessão a notificação faz parte baseado na data today, yesterday, oldest
 */
function getNotificationSection(date) {
  const notificationDate = new Date(date);
  const today = new Date();
  const yesterday = new Date(today.getTime() - 86400000);

  if (notificationDate.toDateString() === today.toDateString()) {
    return 'today';
  } else if (notificationDate.toDateString() === yesterday.toDateString()) {
    return 'yesterday';
  } else {
    return 'oldest';
  }
}

/**
 * Filtra se uma notificação x está ativo nos filtros atualmente e se esssa notificação
 * Faz parte do filtro
 */
function checkIfNotificationIsFiltered(type) {
  const activeTab = $('[data-notification-tab].active').data('notification-tab');

  if (activeTab === 'actions') {
    const notificationTypes = [
      'invoice_overdue_today',
      'invoice_overdue_few_days',
      'report_awaiting_approval',
      'report_disapproved',
      'report_disapproved_by_admin',
      'report_ready_send_approval',
      'fill_society_data',
      'legal_representative_reproved',
      'kyc_approved',
      'legal_representative_approved',
      'kyc_reproved',
      'new_balance_solicitation',
      'receipt_reading_failed',
      'report_partially_approved',
      'report_passed_by_approval_partially'
    ];

    return notificationTypes.includes(type);
  }

  if (activeTab === 'my_expenses') {
    const notificationTypes = [
      'report_awaiting_approval',
      'report_approved',
      'report_disapproved',
      'report_disapproved_by_admin',
      'report_paid',
      'report_ready_send_approval',
      'receipt_reading_success',
      'report_partially_approved',
      'report_passed_by_approval_partially'
    ];

    return notificationTypes.includes(type);
  }

  if (activeTab === 'others') {
    const notificationTypes = [
      'invoice_paid',
      'invoice_tax_receipt_added',
      'invoice_canceled',
      'checking_account_entry_imported',
      'checking_account_transaction',
      'fuel_policy_created',
      'fuel_default_policy_updated',
      'fuel_policy_deleted',
      'fuel_policy_updated'
    ];

    return notificationTypes.includes(type);
  }

  return true;
}

/**
 * Filtra as notificações baseado no filtro ativo
 */
function filterActiveNotifications() {
  const notifications = $('.notifications li > a');
  const sections = $('.notifications section');
  const activeTab = $('[data-notification-tab].active');

  if (notifications.length === 0) { return; }

  notifications.each(function () {
    const type = $(this).data('notification-type');
    const section = $(this).closest('section');
    const totalItems = section.find('li').length;
    const isVisible = checkIfNotificationIsFiltered(type);

    if (!isVisible) {
      $(this).parent().hide();

      // Se não tiver nenhuma notificação visivel some com a section
      if (totalItems === section.find('li:hidden').length) {
        section.hide();
      }

      return;
    }

    // Caso o item e a session não estejam visiveis, mostra eles
    $(this).parent().show();
    section.show();
  });

  activeTab.find('.tabs-counter').html(sections.find('li:visible').length);
};

/**
 * Coloca um novo card na sessão correta de notificações
 */
function appendNotification(notification, html) {
  const sections = $('.notifications section');
  const activeTab = $('[data-notification-tab].active');

  // A notificação é de qual sessão ?  [today, yesterday, oldest]
  const notificationSection = getNotificationSection(notification.date);
  // Verifica se algum dos filtros estão ativos [all, actions, my_expense, others]
  const isNotificationActive = checkIfNotificationIsFiltered(notification.type);

  // Adiciona a notificação  na sessão correta e se ela não estiver visível pelos filtros remove ela
  // E caso a sessão não esteja visível por estar vazia, o show mostra ela
  if (isNotificationActive) { $(`[data-notification-section=${notificationSection}]`).append(html).show(); }
  else { $(html).hide().appendTo($(`[data-notification-section=${notificationSection}]`)); }

  // Atualiza o counter da tab ativa com os itens visíveis
  activeTab.find('.tabs-counter').html(sections.find('li:visible').length);
};

/**
 * Envia a request de marcar uma notificação como lida ou não lida
 *
 * @param {Integer} page
 *
 */
function loadMore(page) {
  sendRequest('GET', route('app.notificacoes.carregar-mais', page))
    .done((response) => {
      response.data.body.forEach(item => {
        const html = createNotificationCard(item.id, item.type, item.content.notification, item);
        appendNotification(item, html);
      });

      $('.notifications-load-more').data('nextPage', page + 1);
      $('#load-more-loader').removeClass('loader');

      if (Object.keys(response.data.body).length < 10) {
        $('.all-notttifications-loaded').removeClass('hidden');
      } else {
        $('.notifications-load-more').removeClass('hidden');
      }
    })
    .fail(() => {
      $('#load-more-loader').removeClass('loader');
      $('.notifications-load-more').removeClass('hidden');
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/common/phrases.ops'),
        message: Lang.get('js/common/phrases.unexpected_error')
      });
    });
};

/**
 * Remove as classes de loading do elemento
 * após marcar notificação como lida/não lida
 *
 * @param {element} element
 *
 */
function removeClasses(element) {
  element.closest('li .notification-card').removeClass('disable-click');
  element.parent().siblings('#read-notification-loader').removeClass('loader');
  element.parent().siblings('img.dots-svg').removeClass('hidden');
};

/**
 * Reseta todas as classes e elementos necessários
 * após marcar todas notificações como lido
 *
 */
function resetReadAllClasses() {
  $('span.badge-count').addClass('hidden');
  $('span.badge-count').first().data('totalUnread', 0);
  $('.total-unread-info').text(0);
  $('#notifications-count').text(0);
  $('#read-all-loader').removeClass('loader');
  $('.notifications-read-all').removeClass('hidden');
};

/**
 * Enviar a request para o servidor
 *
 * @param {bool} isRead
 * @param {element} element
 * @param {string} type
 */
function updateBadges(isRead, element, type) {
  const totalUnread = $('.badge-count').first().data('totalUnread');

  if (isRead) {
    ga4.event('-notificacao_marcarNaoLido')(element);
  }

  element.data('isRead', !isRead);
  element.find('.read-control').data('isRead', !isRead);
  const notificationCard = element.closest('li .notification-card');
  notificationCard.data('isRead', !isRead);

  notificationCard
    .removeClass(isRead ? 'read' : 'unread')
    .addClass(isRead ? 'unread' : 'read');

  notificationCard.find('.icon-circle')
    .removeClass(isRead ? 'read' : 'unread')
    .addClass(isRead ? 'unread' : 'read');

  if (type === 'pdf_ready' || type === 'invoice_tax_receipt_added') {
    element.find('.mark-read-unread').addBack('.mark-read-unread').text(
      isRead ?
        Lang.get('js/src/notificacoes/notificacoes.mark_read') :
        Lang.get('js/src/notificacoes/notificacoes.mark_unread')
    );
  } else {
    element.text(
      isRead ?
        Lang.get('js/src/notificacoes/notificacoes.mark_read') :
        Lang.get('js/src/notificacoes/notificacoes.mark_unread')
    );
  }

  const newTotal = isRead ?
    totalUnread + 1 :
    totalUnread - 1;

  let newTotalHeader = newTotal;
  let newTotalInfo = newTotal;

  if (newTotalInfo <= 0) {
    $('span.badge-count').addClass('hidden');
    $('.notifications-read-all').addClass('disabled');
  } else {
    $('span.badge-count').removeClass('hidden');
    $('.notifications-read-all').removeClass('disabled');
  }

  $('span.badge-count').first().data('totalUnread', newTotal);

  if (newTotal >= 11) {
    newTotalHeader = '10+';
    newTotalInfo = newTotal;
  }

  $('.total-unread-header').text(newTotalHeader);
  $('.total-unread-info').text(newTotalInfo);

  if (newTotal == 1) {
    $('.total-unread-text').text(Lang.get('js/src/notificacoes/notificacoes.unread'));
  } else if (newTotal > 1) {
    $('.total-unread-text').text(Lang.get('js/src/notificacoes/notificacoes.unread_plural'));
  }
}

/**
 * Adiciona uma notificação a lista, recebida via websocket
 *
 * @param {Object} event Evento recebido via websocket
 */
function addNotification(event) {
  if (!event) {
    return;
  }

  const { id, type, notification } = JSON.parse(event.data);
  let { icon } = notification;
  const { url } = notification;

  if (type === 'pdf_ready') {
    updatePdfStatus(url);
  }

  if (!Boolean(window.useNotification)) {
    return;
  }

  const props = notificationProps[type] || notificationProps.default;

  if (!icon || icon === null) {
    ({ icon } = props);
  }

  const html = createNotificationCard(id, type, notification);

  const unreadHeaderElement = $('#notifications-count');

  if ($('#empty-notifications').length) {
    notificationsList(unreadHeaderElement);
  } else {
    $('span.badge-count').removeClass('hidden');
    $('.notifications-read-all').removeClass('disabled');
    let totalUnreadHeader = unreadHeaderElement.text();
    const totalUnread = $('span.badge-count').first().data('totalUnread');

    if (totalUnreadHeader == 10) {
      totalUnreadHeader = '10+';
    }

    if (totalUnreadHeader != '10+') {
      totalUnreadHeader++;
    }

    unreadHeaderElement.text(totalUnreadHeader);
    $('.total-unread-info').text(totalUnread + 1);
    $('span.badge-count').first().data('totalUnread', totalUnread + 1);
  }

  // Adiciona a notificação na sessão correta de acordo com as datas e filtros
  appendNotification({ id, type, notification }, html);
  createNotificationSnackbar(id, type, notification);
};

/**
 * Cria o card de notificação baseado nos elementos
 * criados em resources/views/app/layouts/notificacoes.blade.php
 *
 * @param {Integer} id Id da notificação
 * @param {string} type Tipo da notificação
 * @param {Object} notification Notificação recebida via websocket
 * @param {Object} item Item de notificação recebida via websocket
 */
function createNotificationCard(id, type, notification, item = {}) {
  const { title, message, submessage, url, icon } = notification;
  let svg = '';
  let isRead = false;
  let readClass = 'unread';
  let notificationDate = Lang.get('js/src/notificacoes/notificacoes.now');
  let readUnreadText = Lang.get('js/src/notificacoes/notificacoes.mark_read');

  if (Object.keys(item).length) {
    isRead = item.is_read;
    readClass = item.is_read ? 'read' : 'unread';

    const today = moment();
    const yesterday = moment().subtract(1, 'day');
    notificationDate = moment(item.created_at).isSame(today, 'day') ?
      Lang.get('js/src/notificacoes/notificacoes.today') :
      moment(item.created_at).isSame(yesterday, 'day') ?
        Lang.get('js/src/notificacoes/notificacoes.yesterday') :
        moment(item.created_at).format('DD/MM/YYYY')

    readUnreadText = item.is_read ?
      Lang.get('js/src/notificacoes/notificacoes.mark_unread') :
      Lang.get('js/src/notificacoes/notificacoes.mark_read');
  }

  $.ajax({
    url: `/assets/images/svg/notifications/${icon}.svg`,
    method: 'GET',
    async: false
  })
    .done((response) => {
      const serializer = new XMLSerializer();
      svg = serializer.serializeToString(response.documentElement);
    })

  const html =
    `
      <li>
        <a
        id="notification-card"
        href=\"${url}\"
        class="notification-card read-control media ${readClass}"
        data-notification-type=\"${type}\"
        data-is-read=\"${isRead}\"
        data-notification-id=\"${id}\">
          <div class="media-left">
            <span class="icon-wrap icon-circle ${readClass}">
              ${svg}
            </span>
          </div>
          <div class="media-body">
            <div class="notification-content">
              <div class="notification-messages">
                <div class="text-dark">${title}</div>
                <div>${message}</div>
                <div>${submessage ? submessage : ''}</div>
              </div>
              <div class="notification-date">${notificationDate}</div>
            </div>
          </div>
          <div class="media-right">
            <span class="icon-wrap dropstart">
              <div id="read-notification-loader"></div>
              <img
                  src="/assets/images/svg/notifications/dots.svg"
                  alt="Icon"
                  class="dots-svg dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onmouseover="this.src='/assets/images/svg/notifications/dots-hover.svg';"
                  onmouseleave="this.src='/assets/images/svg/notifications/dots.svg';"
                >
                <div class="dropdown-menu dropdown-menu-left">
                  <span class="mark-read-unread read-control"
                    data-notification-type=\"${type}\"
                    data-is-read=\"${isRead}\"
                    data-notification-id=\"${id}\">
                      ${readUnreadText}
                  </span>
                </div>
            </span>
          </div>
        </a>
      </li>
    `;

  return html;
};

/**
 * Cria o snackbar de notificação baseado no elemento
 * e adiciona a classe responsavel pela animação de fadein e fadeout
 *
 * @param {Integer} id Id da notificação
 * @param {string} type Tipo da notificação
 * @param {Object} notification Notificação recebida via websocket
 */
function createNotificationSnackbar(id, type, notification) {
  const { title, message, submessage, url } = notification;
  const serializer = new XMLSerializer();
  let bellSvg = '';
  let closeSvg = '';

  $.ajax({
    url: '/assets/images/svg/notifications/snackbar-bell.svg',
    method: 'GET',
    async: false
  })
    .done((response) => {
      bellSvg = serializer.serializeToString(response.documentElement);
    })

  $.ajax({
    url: '/assets/images/svg/notifications/snackbar-close.svg',
    method: 'GET',
    async: false
  })
    .done((response) => {
      closeSvg = serializer.serializeToString(response.documentElement);
    })

  const html =
    `
      <div id="snackbar" class="notification-snackbar">
        <a href=\"${url}\"
          class="snackbar-container notification-snackbar-container"
          data-notification-type=\"${type}\"
          data-is-read="false"
          data-notification-id=\"${id}\">
            <div class="snackbar-icon">${bellSvg}</div>
            <div class="snackbar-content">
              <div class="snackbar-title">${title}</div>
              <div class="snackbar-text">${message}</div>
              <div class="snackbar-text">${submessage ? submessage : ''}</div>
              <div class="snackbar-now">${Lang.get('js/src/notificacoes/notificacoes.now')}</div>
            </div>
        </a>
        <div class="snackbar-close">${closeSvg}</div>
      </div>
    `;

  $('#navigation-container').append(html);

  const snackbar = $('.notification-snackbar').addClass('show-snackbar');

  setTimeout(() => {
    snackbar.remove();

    const newTotal = $('.total-unread-header').text();
    const countBadge = $('.badge-header-count').addClass('new-arrived');

    $('.total-unread-header').text('+1');

    setTimeout(() => {
      countBadge.removeClass('new-arrived');

      $('.total-unread-header').text(newTotal);
    }, 1750);
  }, 7500);
};

/**
 * Cria a lista de notificações, caso esteja oculta
 *
 * @param {Element} notificationsCount Elemento referente ao numero de notificações
 */
function notificationsList(notificationsCount) {
  notificationsCount.closest('.badge-count').removeClass('hidden');
  notificationsCount.closest('.badge-count').data('totalUnread', 1);
  notificationsCount.text(1);

  $('#empty-notifications').remove();

  createNotificationElement();
};

/**
 * Cria a lista de notificações, caso esteja oculta
 *
 * @param {Element} notificationsCount Elemento referente ao numero de notificações
 */
function createNotificationElement() {
  const html =
    `
      <div class="notifications-header">
        <div class="notifications-title-content">
          <div class="notifications-title">${Lang.get('js/src/notificacoes/notificacoes.notifications')}</div>
          <span class="badge badge-header-xs badge-count">
            <div class="total-unread-info">1</div>${Lang.get('js/src/notificacoes/notificacoes.unread')}
          </span>
        </div>
        <div class="read-all-container">
          <div id="read-all-loader"></div>
          <a href="#" class="notifications-read-all">${Lang.get('js/src/notificacoes/notificacoes.read_all')}</a>
        </div>
      </div>
      <ul class="head-list">
        <div class="notifications-container">
          <div class="notifications">
            <section data-notification-section='today'>
            </section>

            <section data-notification-section='yesterday'>
            </section>

            <section data-notification-section='oldest'>
            </section>
          </div>
          <div id="load-more-loader"></div>
          <div class="all-notttifications-loaded">${Lang.get('js/src/notificacoes/notificacoes.all_loaded')}</div>
        </div>
      </ul>
    `

  $('#notifications-dropdown').append(html);
};

/**
 * Abre uma nova aba com a nota fiscal emitida da fatura
 *
 * @param {Element} element elemento da notificação de fatura emitida
 */
function openTaxReceipt(element) {
  element.removeClass('disable-click');

  window.open(element.attr('href'), '_blank').focus();
};

/**
 * Enviar a request para o servidor
 *
 * @param {string} method
 * @param {string} url
 * @param {Object} data
 */
function sendRequest(method, url, data = {}) {
  return $.ajax({
    url: url,
    method: method.toUpperCase(),
    data
  });
}

function updatePdfStatus(url) {
  const filenameSplit = url.split('/');
  const filename = filenameSplit[filenameSplit.length - 1].split('.')[0];
  const status = document.getElementById('status-' + filename);
  if (!status) {
    return;
  }
  status.querySelector('.status-processing').textContent = 'Sucesso';
  status.querySelector('span i').className = 'fa fa-check-circle fa-lg text-success';
  const download = document.getElementById('download-' + filename);
  download.innerHTML = `
    <a target='_blank' href=${url}>
      Download
    </a>
    `
};

exports.init = addNotification;
global.addNotification = addNotification;
